import { create } from 'zustand';
import * as judgmentsApi from './judgmentsApi';
import type { Judgment } from './judgmentsApi';

export type { Judgment };

interface JudgmentsState {
  judgments: Judgment[];
  loading: boolean;
  /** Set when the last fetch failed, so a screen can say so instead of rendering "no judgments".
   *  Cleared at the start of every fetch. Mirrors diaryStore / documentsStore. */
  error: string | null;
  fetchJudgments: () => Promise<void>;
  deleteJudgment: (id: string) => void;
}

export const useJudgmentsStore = create<JudgmentsState>()((set, get) => ({
  judgments: [],
  loading: false,
  error: null,

  fetchJudgments: async () => {
    set({ loading: true, error: null });
    try {
      const judgments = await judgmentsApi.fetchJudgments();
      set({ judgments, loading: false, error: null });
    } catch (err) {
      console.error('Failed to fetch judgments:', err);
      set({ loading: false, error: 'Judgments could not be loaded' });
    }
  },

  deleteJudgment: (id) => {
    const removed = get().judgments.find((j) => j.id === id);
    set((s) => ({ judgments: s.judgments.filter((j) => j.id !== id) }));
    judgmentsApi.deleteJudgment(id).catch((err) => {
      console.error('Failed to delete judgment:', err);
      if (removed) set((s) => ({ judgments: [removed, ...s.judgments] }));
    });
  },
}));
